import React, { useEffect, useState } from "react";
import useStyles from "./VendorPopUp.css";
import translation from "../../../i18n/i18.json";
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Autocomplete } from "@material-ui/lab";
import { Country } from "../../../models/Country";
import { BankDetails } from "../../../models/BankDetails";
import {
  VendorBankDetail,
  VendorDetailState,
} from "../../../reducers/vendor/VendorDetailReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import AllActions from "../../../actions";
import {
  FieldsLengthConstants,
  FileUploadTypes,
  InforDisplyaDuration,
  NatureOfBusiness,
  RequestStatus,
  RequestTypes,
  VendorCountry,
  VendorForm1Modes,
} from "../../../constants/AppConstants";
import FileUpload from "../../FileUpload/FileUpload";
import { AccCurency } from "../../../models/AccCurency";
import { SortCode } from "../../../models/SortCode";
import { Common } from "../../../utils/Common";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { VendorDetailBankDetailMeta } from "../../../models/VendorDetail/VendorDetailBankDetailMeta";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { FormUtil } from "../../../utils/FormUtil";
import { FormError } from "../../../models/FormValidation/FormError";
import { Util } from "../../../utils/Util";
import ValidationErrors from "../../ErrorList/ValidationErrors";
import { FileUploadResponse } from "../../../models/FileUploadResponse";

interface BankDetailDialogProps {
  open: boolean;
  handleClose: any;
  //isBankDetaildRequired: any;
  //isSortCodeRequired: any;
  //isSwiftCodeRequired: any;
  countries: Array<Country>;
  bankDetailData: VendorBankDetail;
  isAddBankDetail: boolean;
  isViewBankDetail: boolean;
}

export default function BankDetailDialog(props: BankDetailDialogProps) {
  const {
    open,
    handleClose,
    //isBankDetaildRequired,
    //isSortCodeRequired,
    //isSwiftCodeRequired,
    countries,
    bankDetailData,
    isAddBankDetail,
    isViewBankDetail
  } = props;

  const [acccorencies, setAcccorencies] = useState(Array<AccCurency>());
  const [sortcodes, setSortcodes] = useState(Array<SortCode>());
  const [bankDetails, setBankDetails] = useState(Array<BankDetails>());
  // const [countries, setCountries] = useState(Array<Country>());
  const vendorDetail: VendorDetailState = useSelector<
    RootState,
    VendorDetailState
  >((state) => state.vendorDetails);

  let initialState: VendorBankDetail = {
    id: 0,
    bankCountry:  vendorDetail.AddressCoutry,
    beneficiaryAccName: Util.getBankNameFromVendorName(vendorDetail),
    noObjectionLetterFile: { fileId:0,  fileName: "", filePath:"" },
    beneficiaryAddress: vendorDetail.AddressNumberStreet,
    bankAccNumber: "",
    bankStatementFile: { fileId:0 , fileName: "", filePath:"" },
    bankConfirmationFile: { fileId:0 , fileName: "", filePath:"" },
    bankACKey: "",
    bankAcKeyDesc: "",
    accCurrency: "",
    bankName: "",
    bankAddress: "",
    sortCode: "",
    swiftCode: "",
    ibanCode: "",
    bankNumber: "",
    bankBranch: "",
    modifiedStatus : 0
  };

  const [vendorBankDetail, setVendorBankDetail] =
    useState<VendorBankDetail>(initialState);

  const classes = useStyles();
  const dispatch = useDispatch();

  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [openValidateErrDialog, setOpenValidateErrDialog] = useState(false);
  const [isInitialBankDetailData, setIsInitialBankDetailData] = useState(false);

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const updateBenificiaryAccName = (value: string) => {
    if (vendorDetail.VendorName === value) {
      setVendorBankDetail({
        ...vendorBankDetail!,
        beneficiaryAccName: value,
        beneficiaryAddress: vendorDetail.AddressNumberStreet,
      });
    } else {
      setVendorBankDetail({
        ...vendorBankDetail!,
        beneficiaryAccName: value,
      });
    }
  };

  const updateBankDetails = (
    bankey: string,
    bankeyDesc: string,
    bankname: string,
    bankAddress: string,
    bankBranch: string,
    swiftCode: string,
    bankNumber: string
  ) => {
    setVendorBankDetail({
      ...vendorBankDetail!,
      bankACKey: bankey,
      bankAcKeyDesc: bankeyDesc,
      bankName: bankname,
      bankAddress: bankAddress,
      bankNumber: bankNumber,
      swiftCode: swiftCode,
      bankBranch: bankBranch
    });
  };

  useEffect(() => {
    if (vendorBankDetail.bankCountry && vendorBankDetail.bankCountry !== "") {
      if (!isInitialBankDetailData) {
        prepareForRequest();
        Promise.allSettled([getBankDetails(vendorBankDetail.bankCountry)]).then(
          (values) => {
            compeleteRequest(true);
          }
        );
      }
    } else {
      setBankDetails([]);
    }
  }, [vendorBankDetail.bankCountry]);

  const handleChangeDetails = (input: string) => (e: any) => {
    if (input === "beneficiaryAccName") {
      updateBenificiaryAccName(e.target.value);
    } else if (input === "bankAccNumber") {
      let inputval = e.target.value;
      if (e.target.validity.valid || e.target.value === "") {
        setVendorBankDetail({
          ...vendorBankDetail!,
          bankAccNumber: inputval,
        });
      }
    }
  };

  const handleChangeAutoCompete = (input: string, newValue: any) => {
    if (input === "bankACKey") {
      let bankdata: BankDetails | undefined = {
        bankBranch: "",
        bankKey: { code: "", name: "" },
        bankName: "",
        bankNo: "",
      };
      if (newValue) {
        bankdata = bankDetails.find(function (item: BankDetails) {
          return item.bankKey.code === newValue.bankKey.code;
        });
      }
      if (bankdata && newValue) {
        let backdetails = bankdata.bankKey.name;
        if (backdetails) {
          //US | 121000358 | BANK OF AMERICA | Vernon Branch 0372 | 3810 S. Santa Fe Avenue |  | Vernon California 90058 | 121000358 |  | 121000358 |
          //"US | 021000089 | Citibank NA | NY10017 | 388 Greenwich Street |  | New York | CITIUS33 |  | 021000089 |
          let details = backdetails.split("|");
          let adress = Array<string>();
          let addrNo = details[5] ? details[5].trim() : "";
          let addrStreet = details[4] ? details[4].trim() : "";
          //let addrCity = (details[4])? details[6].trim():"";

          if (addrNo) {
            adress.push(addrNo);
          }

          if (addrStreet) {
            adress.push(addrStreet);
          }
          updateBankDetails(
            bankdata.bankKey.code, // bank code
            bankdata.bankKey.name,
            details[2] ? details[2].trim() : "", //bankdata.bankName, bank name
            //banknameOther, //bank name other
            adress && adress.length > 0 ? adress.join(",") : "", // bank address
            details[3] ? details[3].trim() : "", // - bank branch
            details[7] ? details[7].trim() : "" ,// swift code);
            details[9] ? details[9].trim() : "" // bank number);
          );
        }
      } else {
        updateBankDetails(
          "", // bank code
          "",
          "", //bankdata.bankName, bank name
          "", // bank address
          "", // bank number- bank branch
          "", // swift code
          "" //bankNumber
        );
      }
    } else if (input === "bankCountry") {
      if (newValue) {
        setVendorBankDetail({
          ...vendorBankDetail!,
          bankCountry: newValue.code,
          bankACKey: "",
          bankName: "",
          bankAddress: "",
          bankNumber: "",
          bankBranch: "",
          swiftCode: "",
        });
      } else {
        setVendorBankDetail({
          ...vendorBankDetail!,
          bankCountry: "",
          bankACKey: "",
          bankName: "",
          bankAddress: "",
          bankNumber: "",
          bankBranch: "",
          swiftCode: "",
        });
      }
    }
  };

  const handleChange = (input: string) => (e: any) => {
    setVendorBankDetail({
      ...vendorBankDetail!,
      [input]: e.target.value,
    });
  };

  const handleOnBlur = (input: string) => (e: any) => {
    setVendorBankDetail({
      ...vendorBankDetail!,
      [input]: e.target.value.trim(),
    });
  };

  const handleEnter = (e: any) => {
    // let bankcountry = bankDetailData
    //   ? bankDetailData.bankCountry
    //   : vendorDetail.AddressCoutry;
    // if (bankDetailData) {
    //   setVendorBankDetail(bankDetailData);
    // } else {
    //   setVendorBankDetail({
    //     ...vendorBankDetail!,
    //     bankCountry: vendorDetail.AddressCoutry,
    //     beneficiaryAccName: vendorDetail.VendorName,
    //   });
    // }
    setVendorBankDetail(bankDetailData);
    setIsInitialBankDetailData(true);
    prepareForRequest();
    Promise.allSettled([
      getBankDetailMetaData(),
      getBankDetails(bankDetailData.bankCountry),
    ]).then((values) => {
      compeleteRequest(true);
      setIsInitialBankDetailData(false);
    });
  };

  const handleExit = (e: any) => {
    setVendorBankDetail(initialState);
    setFormErrors([]);
    setFistSubmitDone(false);
  };
  const validateBenifitiaryName = () => {
    if(isEditableBeneficiaryName() && vendorDetail.bankDetailList && vendorDetail.bankDetailList.length > 0){
        var vendorMissMatch = vendorDetail.bankDetailList.find((v) => {
          return v.id != vendorBankDetail.id 
            && v.modifiedStatus != 2
            && v.beneficiaryAccName.trim()
            && v.beneficiaryAccName.trim().toUpperCase() != vendorBankDetail.beneficiaryAccName.trim().toUpperCase();
        });
        if(vendorMissMatch){
          setFormErrors([{ errorMsg: "Beneficiary account names are not matching.", fieldName: "Beneficiary account"}]);
          return false;
        } else {
          return true;
        }
    }
    return true;
  };

  const validateAcNoDuplication = () => {
    if(vendorDetail.bankDetailList && vendorDetail.bankDetailList.length > 0){
        var vendorMissMatch = vendorDetail.bankDetailList.find((v) => {
          return v.id != vendorBankDetail.id 
            && v.modifiedStatus != 2
            && v.bankAccNumber.trim()
            && v.bankAccNumber.trim().toUpperCase() === vendorBankDetail.bankAccNumber.trim().toUpperCase();
        });
        if(vendorMissMatch){
          setFormErrors([{ errorMsg: "Bank Account Number already exists.", fieldName: "Bank Account Number"}]);
          return false;
        } else {
          return true;
        }
    }
    return true;
  };

  const validateCurrencyDuplication = () => {
    if(vendorDetail.bankDetailList && vendorDetail.bankDetailList.length > 0){
        var vendorMissMatch = vendorDetail.bankDetailList.find((v) => {
          return v.id != vendorBankDetail.id 
            && v.modifiedStatus != 2
            && v.accCurrency.trim()
            && v.accCurrency.trim().toUpperCase() === vendorBankDetail.accCurrency.trim().toUpperCase();
        });
        if(vendorMissMatch){
          setFormErrors([{ errorMsg: translation.vendor_detail_bankdetails_same_accurency_error, fieldName: "Bank Account Currency"}]);
          return false;
        } else {
          return true;
        }
    }
    return true;
  };

  const saveBankDetail = (onSaveCallback: (status: boolean) => void) => {
    setFistSubmitDone(true);
    if (validateData() && validateBenifitiaryName() && validateAcNoDuplication()
    && validateCurrencyDuplication()) {
      if (isAddBankDetail) {
        dispatch(
          AllActions.vendorDetailActions.addBankDetails(vendorBankDetail)
        );
      } else {
        dispatch(
          AllActions.vendorDetailActions.editBankDetails(vendorBankDetail)
        );
      }
      setVendorBankDetail(initialState);
      setFormErrors([]);
      setFistSubmitDone(false);
      onSaveCallback(true);
    } else {
      setOpenValidateErrDialog(true);
      onSaveCallback(false);
    }
  };

  const handleSaveCloseBankDetail = (e: any) => {
    saveBankDetail(function (status: boolean) {
      if (status) {
        handleClose();
      }
    });
  };

  const handleSaveBankDetail = (e: any) => {
    saveBankDetail(function (status: boolean) {});
  };

  const getErrorState = (input: string) => {
    // console.log("getErrorState");
    var errIndex = formErrors.findIndex(function (row) {
      return row.fieldName === input && row.errorMsg;
    });
    return errIndex !== -1 ? true : false;
  };

  const isIbanRequired = (countryCode: string) => {
    let country = countries.find(c => c.code == countryCode);
    return country && country.isIbanRequired;
  };

  //// const isSwiftCodeRequired = () => {
  ////   return vendorBankDetail.bankCountry !== VendorCountry.USA;
  //// };

  useEffect(() => {
    if (fistSubmitDone) {
      validateData();
    }
  }, [vendorBankDetail]);

  const validateData = () => {
    setFormErrors([]);
    let validateFieldsData: Array<FormFieldMeta> = [
      {
        fieldName: "bankCountry",
        isRequired: true, //isBankDetaildRequired(),
        reuiredMsg: "Bank Country is required",
      },
      {
        fieldName: "beneficiaryAccName",
        isRequired: vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery 
          || vendorDetail.NatureOfbusiness === NatureOfBusiness.Partnership, //isBankDetaildRequired(),
        reuiredMsg: "Beneficiary Account Name is required",
      },
      {
        fieldName: "beneficiaryAddress",
        isRequired: true, //isBankDetaildRequired(),
        reuiredMsg: "Beneficiary Address is required",
      },
      {
        fieldName: "bankAccNumber",
        isRequired: true, //isBankDetaildRequired(),
        reuiredMsg: "Bank Account Number is required",
      },
      {
        fieldName: "bankACKey",
        isRequired: true, //isBankDetaildRequired(),
        reuiredMsg: "Bank AC Key is required",
      },
      {
        fieldName: "accCurrency",
        isRequired: Common.getSapSystem() != "S4" ? true : false,
        reuiredMsg: "Account Currency is required",
      },
      {
        fieldName: "bankName",
        isRequired: true, //isBankDetaildRequired(),
        reuiredMsg: "Bank Name is required",
      },
      {
        fieldName: "bankAddress",
        isRequired: true, //isBankDetaildRequired(),
        reuiredMsg: "Bank Address is required",
      },
      // {
      //   fieldName: "sortCode",
      //   isRequired: isSortCodeRequired(),
      //   reuiredMsg: "Sort Code is required",
      // },
      {
        fieldName: "swiftCode",
        isRequired: true, //isSwiftCodeRequired(),
        reuiredMsg: "SWIFT/Sort Code is required",
      },
      {
        fieldName: "ibanCode",
        isRequired: isIbanRequired(vendorBankDetail.bankCountry), //Common.isEuCountry(vendorBankDetail.bankCountry),
        reuiredMsg: "IBAN Code is required",
      },
      {
        fieldName: "bankBranch",
        isRequired: true,
        reuiredMsg: "Bank Branch is required",
      },
    ];

    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      vendorBankDetail
    );
    setFormErrors(formValidateData.errorsList);
    let isFieldsValid = formValidateData.isValid;
    //validate account holder name and AC
    // if(isFieldsValid){
    //   let otherBanks = vendorDetail.bankDetailList 
    //     ? vendorDetail.bankDetailList.filter((bnk) => { 
    //         return bnk.bankACKey != vendorBankDetail.bankACKey && bnk.bankAccNumber }) 
    //     : [];
    // }
    return isFieldsValid;
  };

  const getBankDetailMetaData = () => {
    return VendorMasterData.getBankDetailMetaData(
      function (bankData: VendorDetailBankDetailMeta) {
        setAcccorencies(bankData.accountCurencies);
        setSortcodes(bankData.sortKeys);
      },
      function (error: Error) {
        //console.log(error);
        setAcccorencies([]);
        setSortcodes([]);
      }
    );
  };
  const validateBankKey = (bankdata : BankDetails) => {
      let details = bankdata.bankKey.name.split("|");
      let adress = Array<string>();
      let addrNo = details[5] ? details[5].trim() : "";
      let addrStreet = details[4] ? details[4].trim() : "";

      if (addrNo) {
        adress.push(addrNo);
      }

      if (addrStreet) {
        adress.push(addrStreet);
      }
      return (details[2] && details[2].trim() &&  //bankdata.bankName, bank name
      adress && adress.length > 0 && // bank address
      details[3] && details[3].trim() && // bank number- bank branch
      details[7] && details[7].trim() ) ? true : false // swift code);
  };
  const getBankDetails = (bankCountry: string) => {
    //prepareForRequest();
    VendorMasterData.getBankDetails(
      //vendorDetail.AddressCoutry,
      bankCountry,
      function (bankDetail: Array<BankDetails>) {
        //setBanckackeys(bankkeys);
        if(bankDetail && bankDetail.length > 0){
          bankDetail = bankDetail.filter((bnk) => {
              return validateBankKey(bnk);
          });
        }
        setBankDetails(bankDetail);
        // compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        //setBanckackeys([]);
        setBankDetails([]);
        // compeleteRequest(false);
      }
    );
  };

  // const onFileUpload = (fileType: FileUploadTypes, fileId:any) => {
  //   if(fileType === FileUploadTypes.BankNoObjectionLetter){
  //       bankDetailData.noObjectionLetterFile = {fileId: fileId,  fileName: "", filePath:""  };
  //   }
  //   else if(fileType === FileUploadTypes.BankStatement) {
  //     bankDetailData.bankStatementFile = {fileId: fileId,  fileName: "", filePath:""  };
  //   }
  //   else if(fileType === FileUploadTypes.CompanyLetterHeadConfirmingBankAC) {
  //     bankDetailData.bankConfirmationFile = {fileId: fileId,  fileName: "", filePath:""  };
  //   }
  // };

  const isEditableBeneficiaryName = () => {
    return (
      !isViewBankDetail 
      && (vendorDetail.NatureOfbusiness === NatureOfBusiness.SolePropritery ||
      vendorDetail.NatureOfbusiness === NatureOfBusiness.Partnership )
    );
  };

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        onEnter={handleEnter}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {translation.vendorbankdetailpopup_title}
        </DialogTitle>
        <DialogContent>
          <div>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankcounry_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <Autocomplete
                  disabled={isViewBankDetail || !isAddBankDetail}
                  options={countries.map((obj: Country, index: number) => obj)}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, newValue) => {
                    e.preventDefault();
                    handleChangeAutoCompete("bankCountry", newValue);
                  }}
                  value={
                    countries.find(
                      (element: Country) =>
                        element.code === vendorBankDetail.bankCountry
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      disabled={isViewBankDetail}
                      variant="outlined"
                      error={getErrorState("bankCountry")}
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bacontnm_lbl}
              </span>
              <div className={isEditableBeneficiaryName() ? classes.inputWrapper_Req : classes.inputWrapper}>
                <TextField
                  disabled={!isEditableBeneficiaryName()}
                  variant="outlined"
                  value={vendorBankDetail.beneficiaryAccName || ""}
                  onChange={handleChangeDetails("beneficiaryAccName")}
                  error={getErrorState("beneficiaryAccName")}
                  inputProps={{
                    maxLength: FieldsLengthConstants.BeneficiaryAccName,
                  }}
                  onBlur={handleOnBlur("beneficiaryAccName")}
                />
              </div>
            </Grid>
            <Grid
              hidden={
                vendorBankDetail.beneficiaryAccName === vendorDetail.VendorName
              }
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bacontnmupload_lbl}
              </span>
              <div className={classes.inputWrapper}>
                <div className={classes.fileWrapper}>
                  <FileUpload
                    editable={!isViewBankDetail}
                    requestNumber={vendorDetail.RequestNumber}
                    //onFileUpload = {(fileResponse : FileUploadResponse) => { onFileUpload( FileUploadTypes.BankNoObjectionLetter, fileResponse.fileId) }}
                    userfile={vendorBankDetail.noObjectionLetterFile}
                    attachmentType={FileUploadTypes.BankNoObjectionLetter}
                  ></FileUpload>
                </div>
                <span className={classes.helpLbl}>{translation.vendor_detail_bankdetails_bacontnmupload_help}</span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_badress_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  disabled={isViewBankDetail}
                  variant="outlined"
                  value={vendorBankDetail.beneficiaryAddress || ""}
                  onChange={handleChange("beneficiaryAddress")}
                  error={getErrorState("beneficiaryAddress")}
                  inputProps={{
                    maxLength: FieldsLengthConstants.BeneficiaryAddress,
                  }}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankacnum_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  disabled={isViewBankDetail}
                  //type="number"
                  inputProps={{
                    pattern: "[A-Za-z0-9]*",
                    maxLength: FieldsLengthConstants.BankAccNumber,
                  }}
                  variant="outlined"
                  value={vendorBankDetail.bankAccNumber || ""}
                  onChange={handleChangeDetails("bankAccNumber")}
                  error={getErrorState("bankAccNumber")}
                  //inputProps={{ maxLength: 15 }}
                />
              </div>
              <span className={classes.helpLbl}>{translation.vendor_detail_bankdetails_bankacnum_help}</span>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankstateupload_lbl}
              </span>
              <div className={classes.inputWrapper}>
                <div className={classes.fileWrapper}>
                  <FileUpload
                    editable={!isViewBankDetail}
                    requestNumber={vendorDetail.RequestNumber}
                    //onFileUpload = {(fileResponse:FileUploadResponse) => { onFileUpload( FileUploadTypes.BankStatement, fileResponse.fileId) }}
                    userfile={vendorBankDetail.bankStatementFile}
                    attachmentType={FileUploadTypes.BankStatement}
                  ></FileUpload>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankconfupload_lbl}
              </span>
              <div className={classes.inputWrapper}>
                <div className={classes.fileWrapper}>
                  <FileUpload
                    editable={!isViewBankDetail}
                    requestNumber={vendorDetail.RequestNumber}
                    //onFileUpload = {(fileResponse:FileUploadResponse) => { onFileUpload( FileUploadTypes.CompanyLetterHeadConfirmingBankAC, fileResponse.fileId) }}
                    userfile={vendorBankDetail.bankConfirmationFile}
                    attachmentType={
                      FileUploadTypes.CompanyLetterHeadConfirmingBankAC
                    }
                  ></FileUpload>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                <label style={{width: "100%", float: "left"}}>{translation.vendor_detail_bankdetails_bankkey_lbl}</label>
                <label className={classes.infoLabel}>{translation.vendor_detail_bankdetails_bankkey_missing_lbl}</label>
              </span>
              <div className={classes.inputWrapper_Req}>
                <Autocomplete
                  disabled={isViewBankDetail}
                  options={bankDetails.map(
                    (obj: BankDetails, index: number) => obj.bankKey && obj
                  )}
                  getOptionLabel={(option) => option.bankKey.name}
                  onChange={(e, newValue) => {
                    e.preventDefault();
                    handleChangeAutoCompete("bankACKey", newValue);
                  }}
                  value={
                    bankDetails.find(
                      (element: BankDetails) =>
                        element.bankKey.code === vendorBankDetail.bankACKey
                    ) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      error={getErrorState("bankACKey")}
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </div>
            </Grid>
            {(Common.getSapSystem() != "S4") && (<Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_accurency_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <Select
                  disabled={isViewBankDetail}
                  variant="outlined"
                  value={vendorBankDetail.accCurrency || ""}
                  onChange={handleChange("accCurrency")}
                  error={getErrorState("accCurrency")}
                >
                  <MenuItem value="">
                    <em>{translation.dropdown_empty_text}</em>
                  </MenuItem>
                  {acccorencies.map((obj: AccCurency, index: number) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>)}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankname_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
              <TextField
                  disabled
                  variant="outlined"
                  value={vendorBankDetail.bankName || ""}
                  onChange={handleChange("bankName")}
                  error={getErrorState("bankName")}
                  inputProps={{ maxLength: FieldsLengthConstants.BankName }}
                />
                {/* <Select
                  disabled
                  variant="outlined"
                  value={vendorBankDetail.bankName || ""}
                  error={getErrorState("bankName")}
                >
                  {bankDetails.map((obj: BankDetails, index: number) => (
                    <MenuItem key={obj.bankName} value={obj.bankName}>
                      {obj.bankName}
                    </MenuItem>
                  ))}
                </Select> */}
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankad_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  disabled
                  variant="outlined"
                  value={vendorBankDetail.bankAddress || ""}
                  onChange={handleChange("bankAddress")}
                  error={getErrorState("bankAddress")}
                  inputProps={{ maxLength: FieldsLengthConstants.BankAddress }}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_swiftcd_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  disabled
                  variant="outlined"
                  value={vendorBankDetail.swiftCode || ""}
                  onChange={handleChange("swiftCode")}
                  error={getErrorState("swiftCode")}
                  inputProps={{ maxLength: FieldsLengthConstants.SWIFTCode }}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={classes.inputGridItem}
            >
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_ibancode_lbl}
              </span>
              <div
                className={
                  isIbanRequired(vendorBankDetail.bankCountry)
                    ? classes.inputWrapper_Req
                    : classes.inputWrapper
                }
              >
                <TextField
                  disabled={isViewBankDetail}
                  variant="outlined"
                  value={vendorBankDetail.ibanCode || ""}
                  onChange={handleChange("ibanCode")}
                  error={getErrorState("ibanCode")}
                  inputProps={{ maxLength: FieldsLengthConstants.IBANCode }}
                />
                {isIbanRequired(vendorBankDetail.bankCountry) &&
                  (<span className={classes.helpLbl}>{translation.vendor_detail_bankdetails_ibancode_help}</span>)}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.inputGridItem}>
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_bankbranch_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  disabled
                  variant="outlined"
                  value={vendorBankDetail.bankBranch || ""}
                  onChange={handleChange("bankBranch")}
                  error={getErrorState("bankBranch")}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.inputGridItem}>
              <span className={classes.createLbl}>
                {translation.vendor_detail_bankdetails_banknum_lbl}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  disabled
                  variant="outlined"
                  value={vendorBankDetail.bankNumber || ""}
                  onChange={handleChange("bankNumber")}
                  error={getErrorState("bankNumber")}
                />
              </div>
            </Grid>
          </div>
        </DialogContent>
        <div style={{ margin: "25px 0 0 0" }}>
          <DialogActions>
            <div style={{ margin: "20px ​10px 15px 0" }}>
              { !isViewBankDetail && (
                <>
                  <div className={classes.greenBtnWrapper}>
                    <Button onClick={handleSaveBankDetail} color="primary">
                      <CheckCircleIcon></CheckCircleIcon>
                      {isAddBankDetail
                        ? translation.vendorbankdetailpopup_save_add_btntxt
                        : translation.vendorbankdetailpopup_save_edit_btntxt}
                    </Button>
                  </div>
                  <div className={classes.greenBtnWrapper}>
                    <Button onClick={handleSaveCloseBankDetail} color="primary">
                      <CheckCircleIcon></CheckCircleIcon>
                      {isAddBankDetail
                        ? translation.vendorbankdetailpopup_dialog_save_exit_btntxt
                        : translation.vendorbankdetailpopup_dialog_edit_exit_btntxt}
                    </Button>
                  </div>
                </>
              )}
              <div className={classes.grayBtnWrapper}>
                <Button onClick={handleClose} color="primary" autoFocus>
                  {translation.vendorbankdetailpopup_close_btn}
                </Button>
              </div>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <ValidationErrors
        open={openValidateErrDialog}
        setOpen={setOpenValidateErrDialog}
        errorList={formErrors}
      ></ValidationErrors>
    </div>
  );
}
